import { Image } from 'antd';
import Sider from 'antd/lib/layout/Sider';
import Layout from 'antd/lib/layout/layout';
import React, { useContext } from 'react';
import { Outlet, useLocation } from 'react-router-dom';

import { LayoutContext } from './context';

import logo from 'common/assets/icons/ic_careme.svg';
import Sidebar, { MenuItem } from 'common/components/Sidebar';
import useNavigateScroll from 'common/hooks/extends/useNavigateScroll';
import { ROUTE_PATHS } from 'common/utils/constant';

type Props = {
  menus: MenuItem[];
};

const scrollNavigateItems = {
  [ROUTE_PATHS.DASHBOARD_MANAGEMENT]: {
    prevUrl: undefined,
    nextUrl: ROUTE_PATHS.EPIDEMIOLOGY_MANAGEMENT,
  },
  [ROUTE_PATHS.EPIDEMIOLOGY_MANAGEMENT]: {
    prevUrl: ROUTE_PATHS.DASHBOARD_MANAGEMENT,
    nextUrl: ROUTE_PATHS.RISK_OVERVIEW_MANAGEMENT,
  },
  [ROUTE_PATHS.RISK_OVERVIEW_MANAGEMENT]: {
    prevUrl: ROUTE_PATHS.EPIDEMIOLOGY_MANAGEMENT,
    nextUrl: ROUTE_PATHS.RISK_HEART_MANAGEMENT,
  },
  [ROUTE_PATHS.RISK_HEART_MANAGEMENT]: {
    prevUrl: ROUTE_PATHS.RISK_OVERVIEW_MANAGEMENT,
    nextUrl: ROUTE_PATHS.RISK_RENAL_MANAGEMENT,
  },
  [ROUTE_PATHS.RISK_RENAL_MANAGEMENT]: {
    prevUrl: ROUTE_PATHS.RISK_HEART_MANAGEMENT,
    nextUrl: undefined,
  },
};

const Mainlayout: React.FC<Props> = ({ menus }) => {
  const location = useLocation();

  const { collapsed, setCollapsed } = useContext(LayoutContext);

  useNavigateScroll({
    elementQuerySelector: '.t-mainlayout_content',
    cooldownAfterNavigate: 500,
    ...scrollNavigateItems[location.pathname],
  });

  return (
    <Layout>
      <Sider width={collapsed ? 80 : 300}>
        <div className="t-mainlayout_sidebar_header">
          <Image width={collapsed ? 70 : 120} src={logo} preview={false} />
          {/* <Title className={mapModifiers('t-mainlayout_sidebar_branch', collapsed && 'hidden')}>
            Kiosk Careme
          </Title> */}
        </div>
        <div className="t-mainlayout_sidebar_menu">
          <Sidebar
            menuItems={menus}
            collapsed={collapsed}
            handleCollapsed={setCollapsed}
          />
        </div>
      </Sider>
      <Layout className="t-mainlayout_content">
        <Outlet />
      </Layout>
    </Layout>
  );
};

export default Mainlayout;
